<template>
    <iframe width="135" height="107"
            :src="changedUrl"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
</template>

<script>
export default {
    name: "CustomIframe",
    props: ['url'],
    methods: {
        convertYoutube() {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = this.$props.url.match(regExp);

            return '//www.youtube.com/embed/' + match[2]
        }
    },
    computed: {
        changedUrl() {
            if (this.$props.url.search('youtube')) {
                return this.convertYoutube();
            }
        }
    },
}
</script>

<style scoped>

</style>
